<div class="auth-page bg-auth">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-12 col-md-5 col-xl-4 my-5">

        <div class="text-center mb-4"><span class="brand-badge">🎫</span></div>
        <h1 class="display-4 text-center mb-3">Definir palavra-passe</h1>
        <p class="text-muted text-center mb-5">
          Ative o seu acesso em <strong>{{ companyName }}</strong>
        </p>

        @if (!token) {
          <div class="alert alert-danger">Convite inválido: token ausente na URL.</div>
        } @else if (done()) {
          <div class="card">
            <div class="card-body text-center py-6">
              <span class="h1 fe fe-check-circle text-success d-block mb-3"></span>
              <h3 class="mb-2">Palavra-passe definida</h3>
              <p class="text-muted mb-4">O seu acesso está ativo.</p>
              <a class="btn btn-primary" routerLink="/login">Ir para o login</a>
            </div>
          </div>
        } @else {
          <form [formGroup]="form" (ngSubmit)="submit()">
            <div class="form-group">
              <label class="form-label">Nova palavra-passe</label>
              <input class="form-control" type="password" formControlName="password" placeholder="Ao menos 8 caracteres" />
              @if (form.controls.password.touched && form.controls.password.invalid) {
                <small class="text-danger">A palavra-passe tem de ter pelo menos 8 caracteres.</small>
              }
            </div>

            <div class="form-group">
              <label class="form-label">Confirmar palavra-passe</label>
              <input class="form-control" type="password" formControlName="confirm" placeholder="Repita a palavra-passe" />
            </div>

            @if (serverError()) {
              <div class="alert alert-danger">{{ serverError() }}</div>
            }

            <button class="btn btn-lg w-100 btn-primary mb-3" [disabled]="loading()">
              {{ loading() ? 'A guardar…' : 'Ativar acesso' }}
            </button>
          </form>
        }
      </div>
    </div>
  </div>
</div>
